
import { loadModules } from 'esri-loader';
import parse, { DxfParser } from 'dxf-parser';

class MitGisDXFService {
  constructor() {
      //building 45 - close but not exactly it
    //   this.angle = -24.53808;
    //   this.offsetX = 766224.01;
    //   this.offsetY = 2957068.4;
      //The DXF needs to align on top of the coordinates in the json file we get from facilities.
      //Ultimately we are converting everthing to a common latlng which hopefully will make out lives easier
      //and also set us up for integration into other mapping systems
      //Each building has a JSON file and then a DXF file witch contains the structures, doors, windows etc.
      //EACH DXF file has unitless coordinates that are anchored on a random point. This point is used to do converstions.
      //The WLD files are what facilities uses to do this convertion to JSON coordinates but I can't seem to figure out how to calculate angle and offsets from it
      //To make matters worse, building 45 has a different anchor point for each floor.
      //For now I am figuring it out ahead of time and hard coding it here.
      //A better way to do this is probably to set it in the database and use a UI mechanism to set it when needed
      this.adjust = {
        'default':{ angle:-24.7, x: 766723.383644, y: 2956761.05585},
        '32':{
            'default':{ angle:-24.7, x: 766723.383644, y: 2956761.05585}
        },
        '45':{
            'default':{ angle:-24.54, x: 766224.15, y: 2957068.6},
            '0':{ angle:-24.54, x: 766224.15, y: 2957068.6},
            '1':{ angle:-24.54, x: 766227.4, y: 2957066.1},
            '2':{ angle:-24.54, x: 766227.4, y: 2957066.1},
            '3':{ angle:-24.54, x: 766201.2, y: 2957099.1},
            '4':{ angle:-24.54, x: 766201.2, y: 2957099.1},
            '5':{ angle:-24.54, x: 766201.47, y: 2957099.3},
            '6':{ angle:-24.54, x: 766201.47, y: 2957099.3},
            '7':{ angle:-24.54, x: 766201.47, y: 2957099.3},
            '8':{ angle:-24.54, x: 766209.8, y: 2957104.99},
            '9':{ angle:-24.54, x: 766208, y: 2957105}
        }

      }

      //BUILDING 32 offsets and angle for all floors. This isn't the same for building 45 or probably other buildings for some reason.
    //   this.angle = -24.7;
    //   this.offsetX = 766723.383644;
    //   this.offsetY = 2956761.05585;

    //   this.angleCos =  Math.cos(this.ajustment.default.angle); //pre-compute the x angle
    //   this.angleSin = Math.sin(this.ajustment.default.angle); //pre-compute the y angle

      this.pointConvert = {
          convertScalex:null,
          convertScaley:null,
          rotatedX:null,
          rotatedY:null
      };
  }

  initErsi(){
      return new Promise ((resolve, reject) => {
          loadModules(['esri/geometry/Point', 'esri/geometry/projection'])
              .then(([Point, Projection]) => {
                    Projection.load().then(() => {
                        this.Point = Point;
                        this.Projection = Projection;
                        return resolve(true);
                    });
              })
              .catch( (error) => {
                  console.log('FAILED to load esri modules', error);
              });


      });
  }

  convertPointsToLatLong(points){
      let pointsLatLong = [];

      let inSpatialReference = {
          wkid:102686 //MIT spatial reference
      };
      let outSpatialReference = {
        /*
        4326 is the most common spatial reference for storing a referencing data across the
        entire world. It serves as the default for both the PostGIS spatial database and the
        GeoJSON standard. It is also used by default in most web mapping libraries
        */
        wkid: 4326
      };

      let ersiPoints = [];
      for(let i = 0; i < points.length; i++){
          ersiPoints.push(new this.Point({x: points[i][0],y: points[i][1],z: 0, spatialReference: {wkid: inSpatialReference.wkid}}));
      }

      let projectedPoints = this.Projection.project(ersiPoints, outSpatialReference);

      projectedPoints.forEach((p) => {
            //GEOJSON and facilities formats [longitude, lattitude]
            //NOTE: This is opposite of google maps expected order
            pointsLatLong.push([p.x, p.y]);
      });

      return pointsLatLong;
  }

  convertDXFcoordinates(point){

      let result = {
          x:0.0,
          y:0.0
      };

      //first convert the point from inches to feet.
      this.pointConvert.convertScalex = (point.x / 12); //convert to feet
      this.pointConvert.convertScaley = (point.y / 12); //convert to feet from inches

      this.pointConvert.rotatedX = (this.pointConvert.convertScalex * this.angleCos - this.pointConvert.convertScaley * this.angleSin)
      this.pointConvert.rotatedY = (this.pointConvert.convertScalex * this.angleSin + this.pointConvert.convertScaley * this.angleCos)

      result.x = this.pointConvert.rotatedX + this.offsetX;
      result.y = this.pointConvert.rotatedY + this.offsetY;

      return result;
  }

  extractMapData(dxfData, floorLevel,buildingId, manualAdjust){
      return new Promise ((resolve, reject) => {
          const parser = new DxfParser();
          const dxf = parser.parseSync(dxfData);

          let floorAdjust = this.adjust.default;

          //this supports the UI to manually adjust to find the values we want to use
          if(manualAdjust){
            floorAdjust.angle = manualAdjust.angle;
            floorAdjust.x = manualAdjust.x;
            floorAdjust.y = manualAdjust.y;
          }
          else {
              //if we have a building and floor specified for the adjustment use that
              if(this.adjust.hasOwnProperty(buildingId) && this.adjust[buildingId].hasOwnProperty(floorLevel)){
                floorAdjust = this.adjust[buildingId][floorLevel];
              }
              //else if we have a building with no floor use the default for the building
              //CASE: building 32 has the same values for all floors
              else if(this.adjust.hasOwnProperty(buildingId)){
                floorAdjust = this.adjust[buildingId].default;
              }
          }

          this.angleCos =  Math.cos(floorAdjust.angle); //pre-compute the x angle
          this.angleSin = Math.sin(floorAdjust.angle); //pre-compute the y angle

          this.offsetX = floorAdjust.x;
          this.offsetY = floorAdjust.y;

          let data = dxf.entities;

          let result = {
              geoJSON:{
                  "type": "FeatureCollection",
                  "features": []
              },
              floorCoordinates:[],
              spaces:[]
          };

          this.initErsi().then( () => {

              let space = null;

              /*
              LAYERS
                A-DOOR - Doors, which are made up of a line and an arc, we only can use arc for now.
                A-GLAZ - windows
                A-MISC
                A-TEXT
                A-WALL
                A-WALL-CORE
                A-WALL-PHTM
                A-WALL-PRHT
              TYPES
                ARC - Used in part of the door shape, geojson doesn't support arches, so omit for now.
                CIRCLE
                INSERT
                LINE
                LWPOLYLINE
                TEXT
              */

              for(let x = 0; x < data.length; x++){
                  if(data[x].type == 'LINE'){

                      if(data[x].layer == 'A-DOOR'){
                          space = this.createSpace(
                              floorLevel,
                              'DOOR',
                              'DOORS',
                              'door',
                              this.getCoordinates(data[x].vertices),
                              buildingId,
                              data[x].handle
                          );

                          result.spaces.push(space);
                          result.geoJSON.features.push(this.createGeoJSONFeature(space));

                      }
                      else if(data[x].layer == 'A-GLAZ'){
                          space = this.createSpace(
                              floorLevel,
                              'WINDOW',
                              'WINDOWS',
                              'window',
                              this.getCoordinates(data[x].vertices),
                              buildingId,
                              data[x].handle
                          );

                          result.spaces.push(space);
                          result.geoJSON.features.push(this.createGeoJSONFeature(space));
                      }
                      else{
                          result.floorCoordinates.push(this.getCoordinates(data[x].vertices));

                          space = this.createSpace(
                              floorLevel,
                              null,
                              null,
                              'floor',
                              this.getCoordinates(data[x].vertices),
                              buildingId,
                              data[x].handle
                          );
                          //don't add to spaces model list, as we will add the floor coordinates to the
                          //JSON floor representation
                          result.geoJSON.features.push(this.createGeoJSONFeature(space));
                      }
                  }
                  else if(data[x].type == 'LWPOLYLINE'){
                      //Consider adding this,
                  }

              }

              resolve(result);

          });
      });
  }

  getCoordinates(points){
      let c = [];
      let p = null;
      for(let r = 0; r < points.length; r++){
          p = this.convertDXFcoordinates(points[r]);
          c.push([p.x, p.y ]);
      }

      return this.convertPointsToLatLong(c);

  }

  createSpace(level, useType, useCategory, spaceType, coordinates, buildingId,dxfObjectHandle){

      return {
          mitId:buildingId+'-'+level+'-'+dxfObjectHandle,
          mitIdShort:level+'-'+dxfObjectHandle,
          name:'',
          description:'',
          level:level,
          sqfoot:null,
          org: null,
          rotation:0,
          useType: useType,
          useCategory: useCategory,
          spaceType:spaceType,
          geometryCoordinates:coordinates,
          geometryType: 'LineString', //Polygon or LineString
          children:[]
      }
  }

  createGeoJSONFeature(layerSpace){
      return {
          "type": "Feature",
          "geometry": {
              "type": layerSpace.geometryType,
              "coordinates": layerSpace.geometryCoordinates,
          },
          "properties":{
              "mitId":layerSpace.mitId,
              "mitIdShort":layerSpace.mitIdShort,
              "name":layerSpace.name,
              "description":layerSpace.description,
              "level":layerSpace.level,
              "floorId": layerSpace.floorId,
              "sqfoot":layerSpace.sqfoot,
              "org": layerSpace.org,
              "useType": layerSpace.useType,
              "useCategory": layerSpace.useCategory,
              "spaceType":layerSpace.spaceType
          }
      }
  }





}

export default MitGisDXFService;
